import { supervisorType } from "./../../containers/ccsmodule/queues/settings/componenets/supervisorType";
import { Supervisor } from "./../actions/supervisor.action";
import { SupervisorType } from "./../action-types/supervisor.action.type";
import { Queuetype } from "../../containers/ccsmodule/queues/settings/componenets/queueType";
import { SupervisorQueueType } from "../action-types/supervisorQueues.action.types";
import { SupervisorQueueAction } from "../actions/supervisorQueues.action";
import { agentType } from "../../containers/ccsmodule/queues/settings/componenets/agentType";

interface SupervisorQueueRepoState {
  queues: Queuetype[];
  agents: agentType[];
  supervisors: supervisorType[];
}

const initialState = {
  queues: [],
  agents: [],
  supervisors: [],
};

const SupervisorQueueReducer = (
  state: SupervisorQueueRepoState = initialState,
  action: SupervisorQueueAction
): SupervisorQueueRepoState => {
  switch (action.type) {
    case SupervisorQueueType.SET_QUEUES:
      return {
        ...state,
        queues:
          action.payload?.length > 0
            ? action.payload.sort((a: Queuetype, b: Queuetype) =>
                a?.status === "enabled" ? -1 : 1
              )
            : action.payload,
      };

    case SupervisorQueueType.SET_AGENTS:
      return {
        ...state,
        agents: action.payload,
      };
    case SupervisorQueueType.SET_SUPERVISORS:
      return {
        ...state,
        supervisors: action.payload,
      };
    default:
      return state;
  }
};

export default SupervisorQueueReducer;
